import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22d004ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PVSkeleton = _resolveComponent("PVSkeleton")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("span", {
      id: _ctx.id,
      class: _normalizeClass(["ComponentToLoad-alignment", {
        'ComponentToLoad-hidden-to-load': _ctx.loading,
      }])
    }, [
      _renderSlot(_ctx.$slots, "componentToLoad", {}, undefined, true)
    ], 10, _hoisted_1),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_PVSkeleton, {
          key: 0,
          width: _ctx.myWidth + 'px',
          height: _ctx.myHeight + 'px',
          class: _normalizeClass({ SkeletonLoader_alignment: _ctx.marginAuto })
        }, null, 8, ["width", "height", "class"]))
      : _createCommentVNode("", true)
  ]))
}